import { render, staticRenderFns } from "./leaderForm.vue?vue&type=template&id=08913ef7"
import script from "./leaderForm.vue?vue&type=script&lang=js"
export * from "./leaderForm.vue?vue&type=script&lang=js"
import style0 from "./leaderForm.vue?vue&type=style&index=0&id=08913ef7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports